export default __webpack_public_path__ + "images/54_1_image.jpg";